import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import { useForm } from "react-hook-form"; // Import useForm from react-hook-form

import { GetRequest, PatchRequest } from "../../Api/ApiFunctions";
import { ApiUrl, ConfUrl } from "../../Api/EndPoints";
import {
  ConfImageUploadService,
  flattenObject,
  ImageDataModalRequired,
  transformObject,
} from "./constants";
import TextArea from "./Components/TextArea";
import MultipleImage from "./Components/MultipleImage";

const Quality = () => {
  const route = all_routes;
  const [Section1, setSection1] = useState([]);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { isSubmitting },
  } = useForm(); // Set up useForm

  const fetchData = async () => {
    const res = await GetRequest(`${ApiUrl.configuration}${ConfUrl.quality}`);
    if (res) {
      setSection1([res?.value?.section1]);
      const val = flattenObject(res?.value, "");
      Object.keys(val).forEach((key) => {
        setValue(key, val[key]);
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let Req = transformObject(data);
    if (Section1?.length > 0) {
      let imgKey = null;
      if (Section1[0]?.image instanceof File) {
        imgKey = await ConfImageUploadService(Section1[0]?.image);
      }
      Req.section1 = {
        key: Section1[0]?.key,
        image: imgKey ? imgKey : Section1[0]?.image,
        heading: Section1[0]?.heading,
        subHeading: Section1[0]?.subHeading,
      };
    }

    const resp = await PatchRequest(
      `${ApiUrl.configuration}${ConfUrl.quality}`,
      Req
    );
    if (resp) {
      navigate(route.jobapplication);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Unrivalled quality</h4>
              {/* <h6>Create new Career</h6> */}
            </div>
          </div>
        </div>
        {/* /add */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body add-product pb-0">
              <div className="row">
                <div className="col-12">
                  <label className="form-label">
                    Unrivalled quality Heading
                  </label>
                  {/* <TextArea
                    control={control}
                    id="mainHeading"
                    placeholder="Section content"
                  /> */}
                  <input
                    type="text"
                    className="form-control"
                    {...register("mainHeading", {
                      required: "main heading is required",
                    })}
                  />
                </div>
                <h4>
                  <u>Section 1</u>
                </h4>
                <div className="col-12">
                  <MultipleImage
                    id="mainLogo"
                    dataSource={Section1}
                    setDataSource={setSection1}
                    DataRequired={[
                      ImageDataModalRequired.image,
                      ImageDataModalRequired.heading,
                      ImageDataModalRequired.description,
                    ]}
                    DataLimit={1}
                  />
                </div>

                <h4>
                  <u>Section 2</u>
                </h4>
                <label className="form-label">Heading</label>
                <TextArea
                  control={control}
                  id="section2_heading"
                  placeholder="Section content"
                />
                <label className="form-label">Content</label>
                <TextArea
                  control={control}
                  id="section2_subHeading"
                  placeholder="Section content"
                />
                <hr />
                <h4>
                  <u>Section 3</u>
                </h4>
                <label className="form-label">Heading</label>
                <TextArea
                  control={control}
                  id="section3_heading"
                  placeholder="Section content"
                />
                <label className="form-label">Content</label>
                <TextArea
                  control={control}
                  id="section3_subHeading"
                  placeholder="Section content"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="btn-addproduct mb-4">
              <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="spinner-border spinner-border-sm"></span>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </form>
        {/* /add */}
      </div>
    </div>
  );
};

export default Quality;
